<template>

    <Sospensione></Sospensione>
  
</template>
  
  <script>
  import Sospensione from '../components/pratiche/Sospensione.vue';
  
  export default {
    pageName: 'Sospensione',
    components: {
        Sospensione
  
    },
    data() {
      return {
  
      }
    },
  
    created(){
      
    },
  
    mounted(){
      
    },
  
    methods: {
      
    },
  }
  </script>